import { useDebugValue } from 'react';

import { generatedKeys } from '@app/data/queryKeysFactory';
import {
	MutationOptions,
	TApiError,
	useMutation,
	useQuery,
} from '@app/QueryClient';
import {
	createLoyaltySettings,
	freemiumLoyaltySettings,
} from '@app/Services/LoyaltyProgramme';
import {
	TLoyaltySettings,
	TLoyaltySettingsFormValues,
} from '@modules/LoyaltyProgramme/types';

const { freemiumLoyalty } = generatedKeys;

export function useLoyaltySettings() {
	const q = useQuery({
		queryFn: freemiumLoyaltySettings,
		staleTime: Infinity,
		queryKey: freemiumLoyalty?.settings?.({}) ?? [],
	});

	useDebugValue(q);

	return { ...q, data: q?.data?.data as TLoyaltySettings };
}

export function useCreateLoyaltySettings(
	opt: MutationOptions<
		ApiResponse<TLoyaltySettings, object>,
		ApiResponse<TLoyaltySettings, object>,
		TLoyaltySettingsFormValues,
		{
			parsedError?:
				| TApiError<ApiResponse<TLoyaltySettings, object>>
				| undefined;
		}
	>
) {
	const mutation = useMutation<
		ApiResponse<TLoyaltySettings, object>,
		ApiResponse<TLoyaltySettings, object>,
		TLoyaltySettingsFormValues,
		{ parsedError?: TApiError<ApiResponse<TLoyaltySettings, object>> }
	>(createLoyaltySettings, {
		...opt,
		moduleName: 'freemiumLoyalty',
		operation: 'add',
		disableToaster: true,
	});

	const { mutateAsync } = mutation;

	return {
		...mutation,
		doCreateLoyaltySettings: mutateAsync,
	};
}
